
export default {
  props: {
    slide: {
      type: Object,
      required: true,
    },
  },
}
